
// const baseUrl = process.env.NODE_ENV === 'development'
//   ? '/api'
//   : 'https://www.yyyhao.com/api';//正式打包api地址


const baseUrl = process.env.NODE_ENV === 'development'
  ? '/api'
  : 'https://yyyhao.58guoyin.com/api';//测试打包api地址


export default {
  baseUrl,
};